<div class="chat desktop" :class="[{ inverted }]" @click="openChat"></div>